import {
  Box,
  Flex,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@coolblue-development/freddy';
import { DebugInfo } from '@features/filter/types';

export const DrawerContent = ({
  debugInfo,
  productInformation
}: {
  debugInfo: DebugInfo;
  productInformation: { fullName: string; productId: string };
}) => {
  const formatElementText = (text: string): string => {
    return text.replace(/([A-Z])/g, ' $1').trim();
  };

  const updateDebugInfoElements = (debugInfo: DebugInfo): DebugInfo['elements'] => {
    if (!debugInfo.elements.some(element => element.key === 'textMatch')) {
      debugInfo.elements.unshift({
        key: 'textMatch',
        score: 0,
        value: debugInfo.inputScore.toString()
      });
    }

    const priceSensitivityBoost = debugInfo.elements.find(
      (element: { key: string }) => element.key === 'priceSensitivityBoost'
    );

    if (priceSensitivityBoost) {
      priceSensitivityBoost.key = 'personalizedPriceBoosting';
    }

    return debugInfo.elements;
  };

  const debugInfoElements = updateDebugInfoElements(debugInfo);

  return (
    <Flex direction='column' gap={800}>
      <Box>
        <Typography variant='h3' mb={100}>
          Matching fields
        </Typography>
        <Table variant='bordered' layout='fixed'>
          <TableHead>
            <TableRow>
              <TableCell>Field</TableCell>
              <TableCell>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(productInformation).map(([key, value], productInfoIndex) => (
              <TableRow key={`productInfo-${productInfoIndex}`}>
                <TableCell>{key}</TableCell>
                <TableCell>{value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      <Box>
        <Typography variant='h3' mb={100}>
          Boost factors
        </Typography>
        <Table variant='bordered' layout='fixed'>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Value</TableCell>
              <TableCell>Score</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {debugInfoElements.map((boostFactor, boostIndex) => (
              <TableRow key={`boostFactor-${boostIndex}`}>
                <TableCell>
                  <Typography textTransform='capitalize'>
                    {formatElementText(boostFactor.key)}
                  </Typography>
                </TableCell>
                <TableCell>{boostFactor.value}</TableCell>
                <TableCell>{boostFactor.score}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell>Total Score</TableCell>
              <TableCell />
              <TableCell>{debugInfo.score}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
      {debugInfo.matchedQueries.length > 0 && (
        <Box>
          <Typography variant='h3' mb={100}>
            Matchers
          </Typography>
          <Table variant='bordered'>
            <TableHead>
              <TableRow>
                <TableCell>Query</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {debugInfo.matchedQueries.map((matcher, matcherIndex) => (
                <TableRow key={`matcher-${matcherIndex}`}>
                  <TableCell>{matcher}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      )}
    </Flex>
  );
};
